import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BookingModal from '../../components/feature/BookingModal';
import { SEO } from '../../utils/seo';

export default function VanCarPage() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const [galleryType, setGalleryType] = useState<'exterior' | 'interior'>('exterior');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const vehicles = [
    {
      id: 1,
      name: '현대 스타리아 투어러',
      price: '150,000',
      fuel: '디젤(23~25년식)',
      seats: '9,11인승',
      transmission: '자동 스마트키,2채널블박,전동트렁크,자동문',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/a0a0963612144c8db632a074700edd8c.png',
      exteriorImages: [
        'https://public.readdy.ai/ai/img_res/081e010385e9b3fed5e713d08ed409ca.jpg',
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Tourer%20passenger%20van%20exterior%20side%20profile%20view%20in%20modern%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20long%20wheelbase%20and%20distinctive%20horizontal%20design%20language&width=1200&height=800&seq=van-staria-tourer-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Tourer%20passenger%20van%20exterior%20rear%20three-quarter%20view%20in%20modern%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20unique%20horizontal%20LED%20tail%20lamps%20and%20modern%20rear%20design&width=1200&height=800&seq=van-staria-tourer-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Tourer%20van%20interior%20dashboard%20and%20front%20seats%20view%20with%20modern%20black%20upholstery%2C%20digital%20instrument%20cluster%2C%20touchscreen%20display%2C%20spacious%20cabin%20for%20eleven%20passengers%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-staria-tourer-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Tourer%20van%20interior%20center%20console%20and%20control%20area%20close-up%20view%20with%20modern%20materials%2C%20gear%20selector%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-staria-tourer-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Tourer%20van%20interior%20passenger%20seats%20view%20showing%20multiple%20rows%20of%20comfortable%20black%20seating%20for%20eleven%20passengers%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20demonstrating%20spacious%20interior&width=1200&height=800&seq=van-staria-tourer-int-3&orientation=landscape',
      ],
    },
    {
      id: 2,
      name: '기아 카니발4세대 프레스트지',
      price: '180,000',
      fuel: '하이브리드(24년식)',
      seats: '9인승',
      transmission: '자동 스마트키,2채널블박,전동트렁크,자동문',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/5a07063ab5e623c9ee199eb36d1b887d.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Carnival%20fourth%20generation%20minivan%20exterior%20front%20three-quarter%20view%20in%20elegant%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20bold%20tiger%20nose%20grille%20and%20sophisticated%20SUV-like%20design&width=1200&height=800&seq=van-carnival-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Carnival%20fourth%20generation%20minivan%20exterior%20side%20profile%20view%20in%20elegant%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20premium%20proportions%20and%20elegant%20character&width=1200&height=800&seq=van-carnival-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Carnival%20fourth%20generation%20minivan%20exterior%20rear%20three-quarter%20view%20in%20elegant%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20modern%20LED%20tail%20lamps%20and%20refined%20rear%20styling&width=1200&height=800&seq=van-carnival-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Carnival%20minivan%20interior%20dashboard%20and%20front%20seats%20view%20with%20premium%20black%20leather%20upholstery%2C%20dual%20displays%2C%20digital%20cockpit%2C%20luxury%20materials%20for%20nine%20passengers%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-carnival-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Carnival%20minivan%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20electronic%20gear%20selector%2C%20smart%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-carnival-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Carnival%20minivan%20interior%20second%20and%20third%20row%20seats%20view%20with%20luxurious%20black%20leather%20seating%20for%20nine%20passengers%2C%20VIP%20lounge%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20premium%20comfort&width=1200&height=800&seq=van-carnival-int-3&orientation=landscape',
      ],
    },
    {
      id: 3,
      name: '기아 카니발 하이리무진 시그니처',
      price: '250,000',
      fuel: '가솔린(22년식)',
      seats: '7인승',
      transmission: '자동 스마트키,2채널블박,전동트렁크,자동문',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/0919ac9a799a17e2b6b57f691768c679.jpeg',
      exteriorImages: [
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/0919ac9a799a17e2b6b57f691768c679.jpeg',
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/6ea615f13477dbfdc589f36987420ffb.jpeg',
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/f73d4042cffc13d26227ba585ddf12cc.jpeg',
      ],
      interiorImages: [
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/44cd13e22e2574fafeddb825cc2a2d86.jpeg',
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/a94cdef7b7fc16d7b6db4c053be4b33c.jpeg',
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/3ce3949f39f3d4f355cf75fd8b19b44d.jpeg',
      ],
    },
    {
      id: 4,
      name: '현대 스타리아 라운지',
      price: '180,000',
      fuel: '디젤(23년~24년식)',
      seats: '7,9인승',
      transmission: '자동 스마트키,2채널블박,전동트렁크,자동문',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/a0a0963612144c8db632a074700edd8c.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Lounge%20luxury%20van%20exterior%20front%20three-quarter%20view%20in%20premium%20dark%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20futuristic%20premium%20design%20and%20luxury%20character&width=1200&height=800&seq=van-staria-lounge-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Lounge%20luxury%20van%20exterior%20side%20profile%20view%20in%20premium%20dark%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20elegant%20proportions%20and%20distinctive%20styling&width=1200&height=800&seq=van-staria-lounge-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Lounge%20luxury%20van%20exterior%20rear%20three-quarter%20view%20in%20premium%20dark%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20premium%20LED%20lighting%20and%20sophisticated%20rear%20design&width=1200&height=800&seq=van-staria-lounge-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Lounge%20van%20interior%20dashboard%20and%20front%20seats%20view%20with%20luxurious%20beige%20leather%20upholstery%2C%20premium%20displays%2C%20digital%20cockpit%2C%20first-class%20materials%20for%20nine%20passengers%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-staria-lounge-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Lounge%20van%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20luxury%20details%2C%20ambient%20lighting%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-staria-lounge-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Staria%20Lounge%20van%20interior%20VIP%20passenger%20seats%20view%20with%20ultra-luxurious%20beige%20leather%20seating%20for%20nine%20passengers%2C%20executive%20lounge%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20first-class%20luxury%20experience&width=1200&height=800&seq=van-staria-lounge-int-3&orientation=landscape',
      ],
    },
    {
      id: 5,
      name: '현대 쏠라티 럭셔리',
      price: '250,000',
      fuel: '디젤(22년식~26년식)',
      seats: '15인승',
      transmission: '자동 ,2채널블박,자동문',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/9dedacb5b3ff2c14b614832979d8b64f.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20passenger%20van%20exterior%20front%20three-quarter%20view%20in%20professional%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20commercial%20van%20design%20and%20practical%20styling&width=1200&height=800&seq=van-solati-b-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20passenger%20van%20exterior%20side%20profile%20view%20in%20professional%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20tall%20proportions%20and%20spacious%20character&width=1200&height=800&seq=van-solati-b-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20passenger%20van%20exterior%20rear%20three-quarter%20view%20in%20professional%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20practical%20rear%20design%20and%20commercial%20utility&width=1200&height=800&seq=van-solati-b-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20van%20interior%20dashboard%20and%20driver%20area%20view%20with%20practical%20gray%20upholstery%2C%20functional%20controls%2C%20spacious%20cabin%20for%20fifteen%20passengers%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-solati-b-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20van%20interior%20center%20area%20close-up%20view%20with%20practical%20materials%2C%20functional%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-solati-b-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20van%20interior%20passenger%20seats%20view%20showing%20multiple%20rows%20of%20comfortable%20gray%20seating%20for%20fifteen%20passengers%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20demonstrating%20maximum%20passenger%20capacity&width=1200&height=800&seq=van-solati-b-int-3&orientation=landscape',
      ],
    },
    {
      id: 6,
      name: '현대 쏠라티 럭셔리',
      price: '250,000',
      fuel: '디젤(22년식~26년식)',
      seats: '15인승',
      transmission: '자동 2채널블박,열선핸들,열선시트,네비,후카',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/9dedacb5b3ff2c14b614832979d8b64f.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20passenger%20van%20exterior%20front%20three-quarter%20view%20in%20professional%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20commercial%20van%20design%20and%20practical%20styling&width=1200&height=800&seq=van-solati-c-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20passenger%20van%20exterior%20side%20profile%20view%20in%20professional%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20tall%20proportions%20and%20spacious%20character&width=1200&height=800&seq=van-solati-c-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20passenger%20van%20exterior%20rear%20three-quarter%20view%20in%20professional%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20practical%20rear%20design%20and%20commercial%20utility&width=1200&height=800&seq=van-solati-c-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20van%20interior%20dashboard%20and%20driver%20area%20view%20with%20practical%20gray%20upholstery%2C%20functional%20controls%2C%20spacious%20cabin%20for%20fifteen%20passengers%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-solati-c-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20van%20interior%20center%20area%20close-up%20view%20with%20practical%20materials%2C%20functional%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=van-solati-c-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Solati%20van%20interior%20passenger%20seats%20view%20showing%20multiple%20rows%20of%20comfortable%20gray%20seating%20for%20fifteen%20passengers%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20demonstrating%20maximum%20passenger%20capacity&width=1200&height=800&seq=van-solati-c-int-3&orientation=landscape',
      ],
    },
  ];

  const openGallery = (vehicle: any, type: 'exterior' | 'interior') => {
    setSelectedVehicle(vehicle);
    setGalleryType(type);
    setCurrentImageIndex(0);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setSelectedVehicle(null);
  };

  const getCurrentImages = () => {
    if (!selectedVehicle) return [];
    return galleryType === 'exterior' ? selectedVehicle.exteriorImages : selectedVehicle.interiorImages;
  };

  const nextImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "name": "대전승합차렌트카",
        "description": "단체 여행이나 행사에 최적화된 승합차로 모두가 함께 편안하게 이동하세요. 9인승부터 15인승까지 다양한 옵션을 제공합니다.",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/van-car`,
        "isPartOf": {
          "@type": "WebSite",
          "name": "대전렌트카",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        }
      },
      {
        "@type": "ItemList",
        "name": "대전 승합차 렌트 차량 목록",
        "description": "대전렌트카 승합차 렌트 차량 목록",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/van-car`,
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "현대 스타리아 투어러",
            "description": "디젤 23~25년식 9,11인승 승합차, 12시간 렌트 ₩150,000"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "기아 카니발4세대 프레스트지",
            "description": "하이브리드 24년식 9인승 미니밴, 12시간 렌트 ₩180,000"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "기아 카니발 하이리무진 시그니처",
            "description": "가솔린 22년식 7인승 리무진 미니밴, 12시간 렌트 ₩250,000"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "현대 스타리아 라운지",
            "description": "디젤 23~24년식 7,9인승 럭셔리 승합차, 12시간 렌트 ₩180,000"
          },
          {
            "@type": "ListItem",
            "position": 5,
            "name": "현대 쏠라티 럭셔리",
            "description": "디젤 22~26년식 15인승 대형 승합차, 12시간 렌트 ₩250,000"
          }
        ]
      }
    ]
  };

  return (
    <>
      <div className="min-h-screen bg-white">
        <SEO
          title="대전승합차렌트카 - 단체 여행 승합차 렌트 | 대전렌트카"
          description="단체 여행이나 행사에 최적화된 승합차로 모두가 함께 편안하게 이동하세요. 9인승부터 15인승까지 다양한 옵션을 제공합니다. 24시간 예약 가능."
          keywords="대전승합차렌트카, 대전승합차대여, 단체여행렌트카, 9인승렌트카, 15인승렌트카"
          canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/van-car`}
          schema={schema}
        />
        <Navbar />
        <main className="pt-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="mb-12">
              <div className="flex items-center justify-between mb-4">
                <h1 className="text-5xl font-bold text-gray-900">대전승합차렌트카</h1>
                <a 
                  href="tel:010-5437-1535"
                  className="flex items-center gap-3 bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span className="font-semibold">010-5437-1535</span>
                </a>
              </div>
              <p className="text-lg text-gray-600">
                단체 여행이나 행사에 최적화된 승합차로 모두가 함께 편안하게 이동하세요. 
                9인승부터 15인승까지 다양한 옵션을 제공합니다.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {vehicles.map((vehicle) => (
                <div key={vehicle.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="h-64 bg-gradient-to-b from-sky-50 to-white p-6">
                    <img
                      src={vehicle.image}
                      alt={vehicle.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{vehicle.name}</h3>
                    <p className="text-3xl font-extrabold text-primary mb-1">₩{vehicle.price}</p>
                    <p className="text-sm text-gray-500 mb-4">자차별도</p>
                    <div className="grid grid-cols-2 gap-3 mb-6 text-sm text-gray-600">
                      <div className="flex items-center gap-2">
                        <i className="ri-gas-station-line text-primary"></i>
                        <span>{vehicle.fuel}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-user-line text-primary"></i>
                        <span>{vehicle.seats}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-settings-3-line text-primary"></i>
                        <span>{vehicle.transmission}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-calendar-line text-primary"></i>
                        <span>12시간 기준</span>
                      </div>
                    </div>

                    {/* 이미지 갤러리 버튼 */}
                    <div className="flex gap-2 mb-4">
                      <button
                        onClick={() => openGallery(vehicle, 'exterior')}
                        className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-image-line mr-1"></i>
                        외부사진
                      </button>
                      <button
                        onClick={() => openGallery(vehicle, 'interior')}
                        className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-steering-2-line mr-1"></i>
                        내부사진
                      </button>
                    </div>

                    <a 
                      href="tel:010-5437-1535"
                      className="w-full bg-gray-900 text-white py-3 rounded-xl font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap block text-center"
                    >
                      지금 예약하기
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>
        <Footer />
        <BookingModal 
          isOpen={isBookingModalOpen} 
          onClose={() => setIsBookingModalOpen(false)} 
        />

        {/* 이미지 갤러리 모달 */}
        {isGalleryOpen && selectedVehicle && (
          <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
            <button
              onClick={closeGallery}
              className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-4xl"></i>
            </button>

            <div className="w-full max-w-6xl">
              {/* 탭 */}
              <div className="flex justify-center gap-4 mb-6">
                <button
                  onClick={() => { setGalleryType('exterior'); setCurrentImageIndex(0); }}
                  className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    galleryType === 'exterior'
                      ? 'bg-primary text-white'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  외부사진
                </button>
                <button
                  onClick={() => { setGalleryType('interior'); setCurrentImageIndex(0); }}
                  className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    galleryType === 'interior'
                      ? 'bg-primary text-white'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  내부사진
                </button>
              </div>

              {/* 메인 이미지 */}
              <div className="relative aspect-video bg-black rounded-lg overflow-hidden mb-4">
                <img
                  src={getCurrentImages()[currentImageIndex]}
                  alt={`${selectedVehicle.name} ${galleryType === 'exterior' ? '외부' : '내부'} ${currentImageIndex + 1}`}
                  className="w-full h-full object-contain"
                />
                
                <button
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-s-line text-2xl"></i>
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </button>
              </div>

              {/* 썸네일 */}
              <div className="flex justify-center gap-2">
                {getCurrentImages().map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentImageIndex(idx)}
                    className={`w-20 h-20 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
                      idx === currentImageIndex ? 'border-primary' : 'border-transparent opacity-50 hover:opacity-100'
                    }`}
                  >
                    <img src={img} alt={`썸네일 ${idx + 1}`} className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}